<script lang="ts">
  import { createEventDispatcher, setContext } from "svelte";
  import { createFormStore } from "../store";

  let className: string = "w-full";

  export let defaultValues: { [key: string]: any } = {};
  export let id = "form";
  export let name = "form";
  export { className as class };

  export const submitForm = () => handleSubmit();

  // save the initial default values
  const values = { ...defaultValues };
  // Initialize the form store with the provided initial values
  const formStore = createFormStore(values, submitForm);

  // Provide the form store in the context
  setContext("form", formStore);

  const dispatch = createEventDispatcher<{
    submit: any;
    error: { [key: string]: any };
  }>();

  const handleSubmit = async () => {
    // validate the form
    await formStore.validate();

    // dispatch submit event if there are no errors
    if (Object.keys($formStore.errors).length === 0) {
      const values = $formStore.values;
      // extract only the values of the fields that are connected to the form.
      // Some fields may have been dynamically removed from the form.
      const submittedData = Object.keys(values).reduce((acc, key) => {
        const ref = $formStore.refs[key];
        // check single and multi-field refs
        if ((ref && ref.isConnected) || ref?.[0]?.isConnected) {
          acc[key] = values[key];
        }
        return acc;
      }, {} as any);
      dispatch("submit", submittedData);
      // @TODO clean up form values
    } else {
      dispatch("error", $formStore.errors);
    }
  };
</script>

<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
<!--
  ^This is a false positive, we aren't actually evaluating keypresses.
  This is simply used in the `CreateUpdateThreadForm` to prevent default of "Enter"
-->
<form {id} {name} class={className} on:submit|preventDefault={handleSubmit} on:keypress>
  <slot />
</form>
